import { ButtonGroup } from "@vds/buttons";
import { NameStreamOptionalBlueContainer, StreamDescriptiveText, StreamSmallText } from "../../global/components/OnboardingFormStyles/Styles";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";

const NameStream2 = ({ handleSkip, handleGo }) => {
    return (
        <NameStreamOptionalBlueContainer>
            <StreamDescriptiveText>
                To improve app accuracy, complete the advanced stream configuration.
            </StreamDescriptiveText>

            <StreamSmallText>
                Remember, if you skip this step now you can always complete advanced stream configuration later on the Camera Details page.
            </StreamSmallText>

            <ButtonGroup
                childWidth={'100%'}
                viewport={'desktop'}
                rowQuantity={{ desktop: 2 }}              
                data={[
                    {
                        children: "Skip",
                        size: "large",
                        use: "secondary",
                        state: "default",
                        width: "100%",
                        "data-testid": CAMERA_ONBOARDING_TEST_IDS.SKIP_ADVANCED_STREAM_CONFIG_BUTTON,
                        onClick: handleSkip,
                    },
                    {
                        children: "Go",
                        size: "large",
                        use: "primary",
                        width: "100%",
                        "data-testid": CAMERA_ONBOARDING_TEST_IDS.GO_ADVANCED_STREAM_CONFIG_BUTTON,
                        onClick: handleGo
                    },
                ]}
                alignment={"centre"}
            />
        </NameStreamOptionalBlueContainer>
    )
}
export default NameStream2;